import "../../../index.css";
import React, { useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";

HighchartsMore(Highcharts); // Enable additional Highcharts features

const SpeedometerChart = ({ value = 0, meterTitle }) => {
  const val = parseInt(value);
  const chartRef = useRef(null);

  const options = {
    chart: {
      type: "gauge",
      height: 180,
    },
    exporting: {
      enabled: false,
    },
    title: { text: null },
    pane: {
      startAngle: -90,
      endAngle: 90,
      background: null,
    },
    yAxis: {
      lineWidth: 0,
      min: 0,
      max: 100,
      tickPosition: "inside",
      tickLength: 20,
      tickWidth: 0,
      minorTickInterval: null,
      tickPixelInterval: 50,
      labels: {
        step: 2,
        rotation: "auto",
        style: { fontSize: "0px" },
      },
      plotBands: [
        { from: 0, to: val, color: val > 50 ? "#28a745" : "#FFE135", thickness: 20 },
        { from: val, to: 100, color: "#999999", thickness: 20 },
      ],
    },

    series: [
      {
        name: meterTitle,
        data: [val],
        tooltip: { enabled: false },
        dataLabels: {
          enabled: true,
          useHTML: true,
          format: `<div style="text-align:center; margin-top: 5px;">
                      <span style="font-size:14px;font-weight:300;">${meterTitle}</span><br/>
                      <span style="font-size:19px;font-weight:bold;">${val}%</span>
                   </div>`,
          y: 20,
          borderWidth: 0,
          backgroundColor: "transparent",
          shadow: false,
        },
      },
    ],
  };

  return (
    <div style={{ width: "100%", height: "130px", margin: "auto", textAlign: "center" }}>
      <HighchartsReact highcharts={Highcharts} options={options} ref={chartRef} />
    </div>
  );
};

export default SpeedometerChart;
